import {useTexture} from '@react-three/drei'
import { PlaneGeometry, MeshBasicMaterial, MeshPhysicalMaterial } from 'three'

export default function ThreeLogoPanel({position, rotation,isCustomLogo=false, logo, texture,cardMaterial, cardText, cardColor, ...props}){
    
    const rotationFixed = rotation ? [...rotation] : [0,0,0]
    const positionFixed = position ? [...position] : [0,0,0]
    
    rotationFixed[0] -= Math.PI / 2
    positionFixed[1] += .011
    
    if(isCustomLogo && !!cardText) positionFixed[2] -= .05
    
    const image = useTexture(texture)
    const materialOptions = {
        name: "logo material",
        transparent: true,
        // map: image,
        // alphaMap: image,
        // color: "white"
    }
    
    if(cardMaterial.name == "metal"){
        // const canvas = document.createElement("canvas")
        // const img = image.image
        // const {width, height} = img
        // canvas.width = width
        // canvas.height = height
        // const ctx = canvas.getContext("2d")

        
        
        // ctx.drawImage(image)

        

        materialOptions.emissiveMap = image
        materialOptions.alphaMap = image
    } else {
        materialOptions.map = image
    }
    materialOptions.color= cardColor.contrastHex
    
    
    const geometry = new PlaneGeometry(1, 1, 1, 1)
    const material = new MeshBasicMaterial(materialOptions)
    const scale = isCustomLogo ? ( !!cardText ? .30 : .5) : .87

    if(cardMaterial.name == "metal"){
        material.color.set("white")
    }
    
    return (
        <mesh 
            scale={scale}
            geometry={geometry}
            rotation={rotationFixed}
            position={positionFixed}
            material={material}
            />    
    )
}
